import React, { useEffect, useState } from 'react'
import { postAPIForm, getURL, API_URL } from '../app/api';

// Define file type icons
const fileIcons = {
    pdf: '/icons/pdf-icon.png',
    docx: '/icons/docx-icon.png',
    doc: '/icons/docx-icon.png',
    xlsx: '/icons/excel-icon.png',
    xls: '/icons/excel-icon.png',
    txt: '/icons/txt-icon.png',
    default: '/icons/file-icon.png', // Default icon for unknown types
};

export default function FileUploadHandler({ Name = "file", form_data, setFormData, error, setError, Section = 'Files', Label = "Click here to upload file", is_disabled = false }) {
    const [preview, setPreview] = useState({});
    useEffect(() => {
        const fetchURL = async () => {
            const URL = await getURL();
            console.log("Test: ", `${API_URL}/${(form_data[Name] || null)}`);
            // Update the preview when form_data changes
            setPreview({
                url: `${API_URL}/${(form_data[Name] || null)}`,
                type: getFileType((form_data[Name] || null)),
            });
            // setFormData({...form_data})
        };
        if (form_data[Name]) {
            fetchURL(); // Call the async function
        }
    }, [form_data, Name]);

    // Function to determine file type
    const getFileType = (filename) => {
        const extension = filename.split('.').pop().toLowerCase();
        if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) return 'image';
        console.log("getFileType: ", filename, fileIcons[extension] ? extension : 'default')
        return fileIcons[extension] ? extension : 'default';
    };

    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            const formData = new FormData();
            formData.append('baseDir', Section);
            formData.append('filename', 'file');
            formData.append('original_file', file);
            const data = await postAPIForm('/file/uploadFile', formData);
            if (data.status == 0) {
                setError({ status: 0, msg: 'Image Not Uploaded' });
                return;
            } else {
                setPreview({
                    url: `${API_URL}/${(data.filepath || null)}`,
                    type: getFileType((data.filepath || null)),
                });
                setFormData({ ...form_data, [Name]: data.filepath })
            }
        }
    };
    return (
        <>
            <div class="mb-1">
                <label for="formFile" class="form-label">{Label}</label>
                {is_disabled ?
                    <input class="form-control" type="file" id="formFile" disabled={true} />
                    :
                    <input class="form-control" type="file" id="formFile" onChange={handleImageChange} />
                }
            </div>
            {preview && preview?.type && (
                <div className="view-image FormUploadPreview">
                    <div className="close-icon" onClick={() => setPreview(null)}>x</div>
                    {preview.type === 'image' ? (
                        <img src={preview.url} width={20} height={20} alt="Preview" />
                    ) : (
                        <img src={`${API_URL}/uploads${fileIcons[preview.type] || fileIcons.default}`} width={20} height={20} alt="File Icon" />
                    )}
                </div>
            )}
        </>
    )
}
